/**
 * evento-list.ts — APR-10 / APA-2 (openspec/changes/cuentas-pagar-historial-y-gestion-pagos).
 * Response contract for `GET /sumi/cuentas-pagar/comprobantes/:id/eventos`. `type`
 * stays the raw closed-enum string as persisted (`domain/events.ts` in the
 * cuentas-pagar module, which this contracts-self-contained package
 * deliberately does not import) — the human-label mapping is a FRONTEND
 * concern (APA-3.1, Phase 4), never this contract's or the backend's.
 *
 * Spec: openspec/changes/cuentas-pagar-historial-y-gestion-pagos/specs/cuentas-pagar-http-routes/spec.md APR-10
 *       openspec/changes/cuentas-pagar-historial-y-gestion-pagos/specs/cuentas-pagar-auditoria/spec.md APA-2
 * Design: openspec/changes/cuentas-pagar-historial-y-gestion-pagos/design.md "Interfaces / Contracts"
 */
import { z } from 'zod';

export const EventoRowSchema = z.object({
  id: z.string().uuid(),
  type: z.string(),
  actorId: z.string().uuid().nullable(),
  /** APU-9.2 — display name of the actor (never an id); `null` for a system event or an actor that no longer resolves. */
  actorNombre: z.string().nullable(),
  payload: z.record(z.unknown()),
  createdAt: z.string(),
  seq: z.number().int(),
});
export type EventoRow = z.infer<typeof EventoRowSchema>;

export const EventoListResponseSchema = z.object({
  items: z.array(EventoRowSchema),
});
export type EventoListResponse = z.infer<typeof EventoListResponseSchema>;
